import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'

export default class extends Component {
  render () {
    const { component: Component, auth, ...rest } = this.props

    return (
      <Route {...rest} render={props => (
        !auth.isAuthenticated
          ? <Component {...props} />
          : <Redirect to='/admin' />
      )}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/PublicRoute/PublicRoute.jsx